import Modal from "react-modal";
import "../../components/modal/ModalCss.scss";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTimes } from "@fortawesome/free-solid-svg-icons";
import ReactDataTableDisplay from "components/DataTable/ReactDataTableDisplay";
import ModalCondition from "components/ModalCondition";
//import { getUserInfo } from "api/commonUtil";
import { useEffect, useMemo, useState } from "react";
import { sendGet } from "api/restUtil";
import BasicButton from "components/button/BasicButton";

/* 사용자 선택 팝업창 */
export default function UserModal(props) {
    //let userInfo = getUserInfo();

    const { width = 850, height = 650, isOpen, title, onClose, returnData, singleSelectOnly} = props;

    const [userList, setUserList] = useState([]);
    const [pagingInfo, setPagingInfo] = useState({});
    //선택한 사용자 목록
    const [selectList, setSelectList] = useState([]);
    ///선택된 사용자 목록 중 선택한 목록
    const [selected, setSelected] = useState([]);
	// 검색 조건
	// const [conditionList, setConditionList ] = useState([]);

    //사용자 목록 테이블 컬럼
    const columnList = useMemo(() => [
        { header : "사용자 순번", col :"userSeq", notView : true},
        { header : "사번", col : "empNo", cellWidth : "70" },
        { header : "이름", col : "userNm", cellWidth : "100" },
        { header : "직급", col : "rankCdNm", cellWidth : "60" },
        { header : "직책", col : "positionCdNm", cellWidth : "70"},
        { header : "부서", col : "departNm", cellWidth : "136" },
    ], []);

    //선택한 사용자 목록 컬럼
    const selectColumns = useMemo(() => [
        { header : "사용자 순번", col :"userSeq", notView : true},
        { header : "사원번호", col :"empNo", notView : true},
        { header : "이름", col : "userNm", cellWidth : "100" },
        { header : "직급", col : "rankCdNm", cellWidth : "60" },
        { header : "직책", col : "positionCdNm", cellWidth : "60" },
        { header : "부서", col : "departNm",notView: true },
    ], []);
    useEffect(()=> {
		if(isOpen) {
			// 팝업 열때
			fetchAllData();
			setSelectList([]);
			// getConditionList();
		}
    },[isOpen]);
	
	const conditionList = [
		{
			title : "이름",
			col : "userNm",
			type : "input",
		},
		{
			title : "사원번호",
			col : "empNo",
			type : "input",
		},
		{
			title : "직급",
			col : "rankCd",
			type : "commonCodeSelect",
			grpCd: "RANK_CD",
		},
		{
			title :"부서",
			col : "departSeq",
			type : "departSelect",
			// option : departListOption,
		},
		{
			title :"퇴직자",
			col : "includeExitUserYn",
			type : "checkbox",
			label: "포함"
		}
	];


    const fetchAllData = async (condition) => {
		condition = {...condition, cntPerPage: 7}
		const result = await sendGet("/api/user", condition);
		if(result.respCode === "SUCCESS") {
			setUserList(result.data.list);
			setPagingInfo({...result.data, list: [], searchFnc: fetchAllData, searchCond: condition });
		}
    };

    //선택한 사용자 목록
    const returnList=(selects)=> {
        if(singleSelectOnly) {
            ////단일선택
            setSelectList(prev=> {
                const exist = prev.find(item=> item.userSeq === selects.userSeq);
                if(exist) {
                    return prev;
                }
                // const select = {userSeq: selects.userSeq,userNm : selects.userNm, rankCdNm : selects.rankCdNm, empNo : selects.empNo};
                // const datas = [select];
                // return datas;
				return [selects];
            });
        } else {
            ///다중선택 가능
            setSelectList(prev=> {
                const exist = prev.find(item=> item.userSeq === selects.userSeq);
                if(exist) {
                    return prev;
                }
				return [...prev, selects];
                //사용자 정보 추가(사번, 부서명) by yhb 2025.02.04
                // const select = {userSeq: selects.userSeq,userNm : selects.userNm, rankCdNm : selects.rankCdNm, empNo: selects.empNo, departNm: selects.departNm};
                // const datas = [...prev,select];
                // return datas;
            });
        }
    }
    const isEqual=(arr1, arr2) => {
        if(arr1.length !== arr2.length) {
            return false;
        }

        for( let i=0;i<arr1.length;i++) {
            const userSeq = arr1[i].userSeq;
            const matchFound = arr2.some(item => item.userSeq === userSeq);
            if(!matchFound) {
                return false;
            }
        }

        return true;
    }

    ////선택한 사용자 중에 체크 박스 선택
    const returnSelectRows=(data)=> {
        // const flag = isEqual(data, selected);
        // if(!flag) {
        //     setSelected(data);
        // }
		setSelected(data);
    };

    //선택한 사용자에서 제외
    const delSelect=()=> {
        const newSelect = selectList.filter(item=> !selected.map(selects=> selects.userSeq).includes(item.userSeq));
        setSelectList(newSelect);
    };

    const onClick=()=> {
        if(!selectList || selectList.length ===0) {
            alert("사용자를 선택해주세요.");
        } else {
            returnData && returnData(selectList);
            // setSelectList([]);
            // onClose();
        }
    };
    
    return (
        <Modal
            appElement={document.getElementById("root")}
            isOpen={isOpen}
            onRequestClose={onClose}
            contentLabel={title}
        >
            <div className="me-modal">
                <div className="me-modal-container" style={{width, height}}>
                    <div className="me-modal-inner">
                        <div className="me-modal-header handle-area">
                            <h4 className="header-title">{title}</h4>
                            <div className="header-close" onClick={onClose}>
                                <FontAwesomeIcon icon={faTimes} className="button" size="lg"/>
                            </div>
                        </div>

                        <div className="me-modal-body" >
                            <div className="body-area" style={{gap:0,width : "440px", height: "535px", display : "inline-block", verticalAlign:"top"}}>
                                <ModalCondition conditionList={conditionList} onSearch={fetchAllData} refresh={false}/>
                                <ReactDataTableDisplay
                                    columns={columnList}
                                    customDatas={userList}
                                    //returnSelectRows={returnList}
                                    rowClick={returnList}
                                    isPageNation={false}
                                    defaultPageSize={5}
                                    hideCheckBox={true}
									pagingInfo={pagingInfo}
                                    
                                />
                            </div>

                            <div className="body-area" style={{width: "20px", display: "inline-block" , verticalAlign : "top"}}></div>

                            <div className="body-area" style={{gap:0,width : "340px",display : "inline-block", verticalAlign:"top"}}>
								<div className="mg-b-10">
									<BasicButton
										label="제외"
										className="btn-del"
										onClick={delSelect}
										disabled={selected.length === 0}
									/>
								</div>
                                <ReactDataTableDisplay
                                    columns={selectColumns}
                                    customDatas={selectList}
                                    returnSelectRows={returnSelectRows}
                                    isPageNation={false}
									percentageWidth={true}

									

                                />
                            </div>
                        </div>

                        <div className="me-modal-footer mg-t-10 mg-b-20">
                            <div className="table-buttons" style={{justifyContent : "center"}}>
								<BasicButton
									label="취소"
									className="btn-cancel"
									style={{width: "100%"}}
									onClick={onClose}
								/>
								<BasicButton
									label="확인"
									className="btn-save"
									style={{width: "100%"}}
									onClick={onClick}
								/>

                            </div>
                        </div>

                    </div>

                </div>
            </div>
        </Modal>
    )
};